import React, { useEffect, useState, useRef } from 'react'
import { parseString } from 'xml2js';
import DownloadTable from './DownloadTable';

export default function ListaDadosBasicosConservacao(props) {
    const tableRef = useRef();
    const [table, setTable] = useState(props.table);
    const fileNameTemplate = table.linhas[0][0][2][0];

    return (
        <>
            <DownloadTable tableRef={tableRef} template={fileNameTemplate} />
            <table ref={tableRef} className="table  table-sm small table-hover" id='table_dados_basicos_conservacao'>
                <thead>
                    <tr>
                        {table.cabecalho.map((cabecalho, i) => <th className={i > 1 && 'text-right'} key={cabecalho} > <span style={{ textTransform: 'uppercase' }}>{cabecalho} </span> </th>)}
                    </tr>
                </thead>
                <tbody>
                    {table.linhas.map(linhas =>
                        <tr key={Math.random()}>
                            {linhas.map(linha =>
                                <>
                                    <td key={linha[0]}> {linha[0]} </td>
                                    <td key={Math.random()}> {linha[1]} </td>
                                    {linha[2].map(item => <td className='text-right' key={Math.random()}> {item.valor} </td>)}
                                </>)}
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    )
}

